class AbTestingSdk {
    _experiments;
    _statistics;
    _userData;
    constructor(params) {
        const { experiments, statistics, userData } = params;
        this._experiments = experiments;
        this._statistics = statistics;
        this._userData = userData;
    }
    checkExperiment(name) {
        const experimentsNames = Object.keys(this._experiments);
        return experimentsNames.includes(name);
    }
    checkExperimentVariant(experimentName, variantValue) {
        const variant = this.getExperimentVariant(experimentName);
        return variant === variantValue;
    }
    getExperimentVariant(name) {
        const value = this._experiments[name];
        if (typeof value === 'undefined')
            return null;
        return value;
    }
    getAllUserExperiments() {
        if (!this._experiments || Object.keys(this._experiments).length === 0)
            return null;
        return this._experiments;
    }
    getUserId() {
        return this._userData.id ?? null;
    }
    getAnalyticsStatistics() {
        const statistics = this._statistics;
        const userId = this.getUserId();
        if (!userId || !statistics)
            return null;
        return {
            statistics,
            userId
        };
    }
}

export { AbTestingSdk };
//# sourceMappingURL=sdk.js.map
